import CommentSection from "./components/CommentSection";

const commentPlugin = {
  install(app) {
    app.component("comment-section", CommentSection);
  },
};

export default commentPlugin;
